module.exports = __webpack_public_path__ + "static/probate-photo-427c5b73ea2e1daf94272f2d80908ed5.jpg";